<template>
    <div id="review--overnight">
        <div class="review--block--header" @click="() => { this.$emit('toggled', { selected: this.selected }) }">
            <div class="review--block--header--icon" v-html="overnight"></div>
            <div class="review--block--header--title">
                <div>
                    {{ service.details.title }}
                </div>
            </div>
            <div class="review--block--header--checked" v-html="checked"></div>
        </div>
        <div v-show="opened">
            <div class="panel tiny-mce" transparent noradius noshadow v-if="service.public_data.service_notes" v-html="service.public_data.service_notes"></div>
            <review-agent-notes v-if="service.public_data.agent_notes" :agent_notes="service.public_data.agent_notes" />
            <div class="panel" noradius>
                <review-service-highlight
                    :price="service.public_data.public_price"
                    :departure_date="details.min_checkin"
                    :return_date="details.max_checkout"
                    :adults="this.$store.state.quote.details.occupancy ? this.$store.state.quote.details.occupancy.adults : ''"
                    :children="this.$store.state.quote.details.occupancy ? this.$store.state.quote.details.occupancy.children : []"
                />                
            </div>
            <div class="review--block--body">
                <b-form-radio-group v-model="selected">
                    <div v-for="hotel in service.details.hotels" v-bind:key="hotel.hotel_index">
                        <div class="review--option">
                            <div class="review--option--content">
                                <div class="review--hotel">
                                    <div class="review--hotel--infolist">
                                        <div>
                                            <div class="review--hotel--infolist--item green">
                                                <div class="review--hotel--infolist--icon" v-html="buildings"></div>
                                                <div class="review--hotel--infolist--content">{{ hotel.property_name }}</div>
                                            </div>
                                            <div class="review--hotel--infolist--item">
                                                <div class="review--hotel--infolist--icon" v-html="geo"></div>
                                                <div class="review--hotel--infolist--content">{{ hotel.city }}</div>
                                                <!--{{ hotel.address }}, {{ hotel.city }} - {{ hotel.country_code }}-->
                                            </div>
                                            <div class="review--hotel--infolist--item">
                                                <div class="review--hotel--infolist--icon" v-html="calendar"></div>
                                                <div class="review--hotel--infolist--content">IN {{ reverse_date(hotel.checkin) }} - OUT {{ reverse_date(hotel.checkout) }}</div>
                                            </div>
                                            <div class="review--hotel--infolist--item">
                                                <div class="review--hotel--infolist--icon" v-html="bedding"></div>
                                                <div class="review--hotel--infolist--content">
                                                    <div v-for="(room,index) in hotel.rooms" v-bind:key="index">
                                                        {{ room.qty }} {{ room.room_name }} {{ room.bedding }} {{ room.treatment }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="review--hotel--infolist--modals">
                                                <p class="mt-4" v-if="hotel.property_info">
                                                    <b-button size="sm" variant="primary" v-b-modal="'modal-info-' + service.service_index + '-' + hotel.hotel_index">Descrizione e condizioni</b-button>
                                                    <b-modal size="xl" :id="'modal-info-' + service.service_index + '-' + hotel.hotel_index" title="Descrizione e condizioni" hide-footer>
                                                        <div v-html="hotel.property_info"></div>
                                                    </b-modal>
                                                </p>
                                                <p class="mt-4" v-if="hotel.property_important_info">
                                                    <b-button size="sm" variant="primary" v-b-modal="'modal-important-info-' + service.service_index + '-' + hotel.hotel_index">Informazioni importanti</b-button>
                                                    <b-modal size="xl" :id="'modal-important-info-' + service.service_index + '-' + hotel.hotel_index" title="Informazioni importanti" hide-footer>
                                                        <div v-html="hotel.property_important_info"></div>
                                                    </b-modal>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="review--hotel--gallery" v-if="hotel.gallery && hotel.gallery.length > 0">
                                        <div class="review--hotel--gallery--slider">
                                            <span class="slick-arrow" id="slick-prev" :prev="'slick-prev-' + service.service_index + '-' + hotel.hotel_index">
                                                <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path opacity="0.6" d="M30 59.9992C46.5685 59.9992 60 46.5681 60 29.9996C60 13.4311 46.5685 0 30 0C13.4315 0 0 13.4311 0 29.9996C0 46.5681 13.4315 59.9992 30 59.9992Z" fill="white"/>
                                                <path d="M33.5758 43.5237L20.2078 30.0001L33.5758 16.4766" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </span>
                                            <span class="slick-arrow" id="slick-next" :next="'slick-next-' + service.service_index + '-' + hotel.hotel_index">
                                                <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path opacity="0.6" d="M30 59.9992C46.5685 59.9992 60 46.5681 60 29.9996C60 13.4311 46.5685 0 30 0C13.4315 0 0 13.4311 0 29.9996C0 46.5681 13.4315 59.9992 30 59.9992Z" fill="white"/>
                                                <path d="M33.5758 43.5237L20.2078 30.0001L33.5758 16.4766" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </span>
                                            <slick v-if="opened" :options="dynamic_slick_options(service.service_index + '-' + hotel.hotel_index)" :ref="'slick-' + service.service_index + '-' + hotel.hotel_index">
                                                <div class="review--hotel--gallery--item" v-for="(image,index) in hotel.gallery" v-bind:key="index">
                                                    <div class="review--hotel--gallery--image" :style="'background-image:url('+image+')'"></div>
                                                </div>
                                            </slick>    
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="review--option--control">
                                <b-form-radio name="review-overnights" :value="hotel.hotel_index"></b-form-radio>
                            </div>
                        </div>
                    </div>
                </b-form-radio-group>
            </div>
            <div class="panel" transparent noradius noshadow v-if="service.public_data.public_notes">
                <div class="review--title--small">
                    <strong>Note, istruzioni e condizioni della soluzione</strong>
                </div>
                <div class="tiny-mce" v-html="service.public_data.public_notes"></div>
            </div>
            <!--
            <div class="review--block--footer">
                <button-with-icon
                    variant="cta"
                    text="Chiudi"
                    :disabled="selected == -1"
                    :icon="chevron_right"
                    :clicked="() => { this.$emit('completed', { selected: this.selected }) }"
                />
            </div>-->
        </div>
    </div>
</template>

<script>
    import Slick from 'vue-slick'
    //import Bwi from '@/components/atoms/button-with-icon'
    import ReviewServiceHighlight from '@/components/review/review-service-highlight'
    import ReviewAgentNotes from '@/components/review/review-agent-notes'
    //import { validate_fields } from '@/validate'
    import { bedding, checked, info, buildings, overnight, geo, calendar } from '@/components/svg/common'
    import { chevron_right } from '@/components/svg/chevrons'
    import {reverse_date} from '@/utilities'

    export default {
        name: 'review-overnight',
        components: {
            'slick': Slick,
            //'button-with-icon': Bwi,
            'review-service-highlight': ReviewServiceHighlight,
            'review-agent-notes': ReviewAgentNotes,
        },
        props:
        {
            opened: {
                type: Boolean,
                default: false,
            },
            service: {
                type: Object,
                default: () => {}
            },
            details: {
              type: Object,
              default: () => {}
            },
        },
        created()
        {
            this.bedding = bedding
            this.checked = checked
            this.info = info
            this.chevron_right = chevron_right
            this.buildings = buildings
            this.overnight = overnight
            this.geo = geo
            this.calendar = calendar
            //this.validate_fields = validate_fields
            this.reverse_date = reverse_date
        },
        data() {
            return {
                selected: 0,//-1,
                options: [],
                /*slick_options:
                {
                    slidesToShow: 1,
                    dots: false,
                    fade: true,
                    prevArrow: '[prev='+this._uid+']',
                    nextArrow: '[next='+this._uid+']',
                }*/
            }
        },
        computed: {


        },
        mounted() {
            this.$emit('completed', { selected: this.selected })
            this.service.details.hotels.forEach(hotel => {
                this.options.push(hotel.hotel_index)
            })
        },
        methods:{

          dynamic_slick_options(service_id_hotel_id){
            return {
              slidesToShow: 1,
              dots: false,
              fade: true,
              prevArrow: '[prev=slick-prev-'+service_id_hotel_id+']',
              nextArrow: '[next=slick-next-'+service_id_hotel_id+']',
            }
          },

        },
        watch: {
            /*
            opened() {
            }
            */
        },
    }
</script>

<style lang="scss">
    #review-overnight
    {
        .review--hotel--gallery--slider
        {
            display:block;
            width:100%;
            height:100%;
            position:relative;
        }
        .slick-arrow
        {
            z-index: 1;
            position:absolute;
            top:50%;
            transform:translateY(-50%);
            cursor: pointer;
            svg
            {
                width:40px;
                height:40px;
            }
            &#slick-prev
            {
                left:20px;
            }
            &#slick-next
            {
                right:20px;
                svg
                {
                    transform:rotate(180deg);
                }
            }
        }
        .review--option
        {
            display:block;
        }
        .review--hotel
        {
            &--infolist
            {
                width:100%;
                @include media-breakpoint-up(md)
                {
                    float:left;
                    width:50%;
                    padding-right:$grid-gutter-width/2;
                }
                &--item
                {
                    display:flex;
                    width:100%;
                    margin-bottom:0.75rem;
                    padding-bottom:0.75rem;
                    border-bottom:1px solid $light;
                    &.green
                    {
                        color:$green;
                        font-weight: bold;
                        svg
                        {
                            path
                            {
                                fill:$green;
                            }                            
                        }
                    }
                }
                &--icon
                {
                    width:40px;
                    text-align:left;
                    path
                    {
                        fill:$text;
                    }
                    svg
                    {
                        max-width: 18px;
                        max-height: 20px;
                    }
                }
                &--content
                {
                }
            }
            &--gallery
            {
                width:100%;
                @include media-breakpoint-up(md)
                {
                    float:left;
                    width:50%;
                    padding-left:$grid-gutter-width/2;
                }
                &--item,
                &--image
                {
                    background-size: cover;
                    background-position:center center;
                    display: block;
                    height: 200px;
                    max-width:100%;
                    @include media-breakpoint-up(md)
                    {
                        height: 240px;
                    }
                    @include media-breakpoint-up(lg)
                    {
                        height: 320px;
                    }
                }
                .slick-dots
                {
                    flex-wrap: wrap;
                    align-items: center;
                    justify-content: center;
                    li
                    {
                        //padding:0;
                    }
                    button
                    {
                        padding:0;
                        width:8px;
                        height:8px;
                        border-radius: 4px;
                    }
                }
            }
        }
        .review--option--room
        {
            &>div
            {
                display:flex;
                text-align: left;
                strong
                {
                    width:40%;
                }
                span
                {
                    width:60%;
                }
            }
        }
    }
</style>